export function logDailyEvent(e) {
  if (window.location.hostname === 'localhost') {
    console.log('[daily.co event]', e.action)
  }
}
